import React from 'react';
import ExamSubjects from './ExamSubjects';

export default function ExamLectureSubject() {
  return <ExamSubjects categoryId={3} />;
}
